import { memo } from "react";
import renameimg from "../../assets/images/rename.svg";
import {
  FormatValueDecimal,
  calculateNetPrice,
  ConvertFromBase,
} from "../../utils/Validate";
import Forecasts from '../../assets/images/forecast.png'
const canViewCosting = (userProfile) =>
  userProfile?.canViewCosting &&
  (userProfile?.canViewCostingOverride === true ||
    userProfile?.canViewCostingOverride === null);

const canEditCommercials = (userProfile) =>
  userProfile?.specialPermissions?.indexOf(2) > -1;

const getMarkThumbnail = (item) =>
  item?.imageUrl ||
  item?.productImageUrl ||
  item?.productImage ||
  item?.thumbnailUrl ||
  item?.productItems?.[0]?.imageUrl ||
  item?.productItems?.[0]?.productImageUrl ||
  item?.productItems?.[0]?.productImage ||
  item?.productItems?.[0]?.thumbnailUrl ||
  "";

const getRowClassName = ({
  item,
  selectedLineCancelled,
  quotePending,
}) => {
  const classNames = [];

  const approvalLine = quotePending?.data?.lines?.find(
    (line) => String(line?.quoteProductId) === String(item?.id)
  );
  const status = approvalLine?.status || item?.approvalStatus || item?.status;

  if (
    item?.currentUserApprovalScope === "Actionable" &&
    item?.isActionableForCurrentUser
  ) {
    classNames.push("highlight-row");
  } else if (status === "Pending") {
    classNames.push("highlight-row-pending");
  } else if (
    (status === "Approved" || status === "RequiresResubmission") &&
    !(status === "RequiresResubmission" && selectedLineCancelled)
  ) {
    classNames.push("highlight-row-approved");
  } else if (status === "Rejected") {
    classNames.push("highlight-row-rejected");
  } else if (status === "Cancelled") {
    classNames.push("highlight-row-cancelled");
  } else if (Number(item?.margin) < 0) {
    classNames.push("negative-margin-row");
  }

  return classNames.join(" ");
};

const ProductMarkCell = memo(function ProductMarkCell({
  item,
  rename,
  renameError,
  onEdit,
  onRename,
  onRenameBlur,
  onRenameChange,
  onRenameKeyDown,
}) {
  const markThumbnail = getMarkThumbnail(item);

  return (
    <td className="product-mark-cell">
      <div className="product-mark-main">
        <div className="product-mark-thumb" aria-hidden="true">
          {markThumbnail ? <img src={markThumbnail} alt="" /> : <i className="fas fa-cube"></i>}
        </div>
        {rename?.id === item?.id ? (
          <input
            type="text"
            className="form-control product-mark-rename-input"
            name="txtmarkName"
            value={rename?.markName}
            onKeyDown={onRenameKeyDown}
            onBlur={onRenameBlur}
            maxLength={50}
            onChange={(e) => onRenameChange(e.target.value)}
            style={{ border: rename?.id === item?.id && renameError && "1px solid red" }}
          />
        ) : (
          <button
            type="button"
            className="product-mark-link"
            title={item?.markName}
            onClick={onEdit}
          >
            {item?.markName}
          </button>
        )}
        <div className="product-mark-actions">
          <button type="button" title="Edit mark" onClick={onRename}>
            <img src={renameimg} alt="Rename" />
          </button>
        </div>
      </div>
    </td>
  );
});

const ProductMarginCell = memo(function ProductMarginCell({
  errorItem,
  rangeErrorItem,
  index,
  item,
  productDiscount,
  onActionableApproval,
  onBlur,
  onChange,
}) {
  const isNegativeMargin = Number(item?.margin) < 0;
  const activeError = rangeErrorItem?.message
    ? rangeErrorItem.message
    : errorItem
      ? `Please enter the value greater than ${productDiscount}`
      : null;

  return (
    <td data-label="Margin(+) / Discount(-)"
      style={{ textAlign: "right" }}
      className={`validation-popup product-margin-cell ${isNegativeMargin ? "negative-margin" : ""}`}
    >
      <div className="d-flex">
        <div className="d-flex align-items-center">
          <input
            type="number"
            id={`product-margin-${item?.id || index}`}
            name={`productMargin-${item?.id || index}`}
            step="0.01"
            style={{ textAlign: "right" }}
            className={`form-control product-margin-input ${isNegativeMargin ? "negative-margin-input" : ""} ${activeError ? "is-invalid" : ""}`}
            placeholder="Enter"
            value={item?.margin}
            onChange={(e) => onChange(e, item)}
            onBlur={(e) => onBlur(e, item)}
          />

        </div>
        {activeError && (
          <span className="popover__wrapper">
            <div className="popover__content">
              <p className="form-error text-left mt-1">{activeError}</p>
            </div>
          </span>
        )}
        {item?.currentUserApprovalScope === "Actionable" && item?.isActionableForCurrentUser && (
          <div className="action-buttons mt-2 d-flex justify-content-end">
            <button className="btn btn-success btn-sm" onClick={(e) => onActionableApproval(e, item)}>
              <i className="fa fa-check"></i>
            </button>
          </div>
        )}
      </div>
    </td>
  );
});

const ProductRowActions = memo(function ProductRowActions({
  item,
  isRequester,
  quotePending,
  onApprovalIndicator,
  onCopy,
  onDelete,
  onForecast,
  onItemForecast,
  isRevisionDraft = false,
}) {
  const approvalLine = quotePending?.data?.lines?.find(
    (line) => String(line?.quoteProductId) === String(item?.id)
  );
  const approvalStatus = approvalLine?.status || item?.approvalStatus || item?.status;

  return (
    <td className="action-icon product-row-actions-cell">
      <div className="product-row-actions">
        <button
          type="button"
          className="product-row-action-btn"
          title={isRevisionDraft ? "Forecast unavailable while revision draft is active" : "Forecast"}
          onClick={onForecast}
          disabled={isRevisionDraft}
        >
          <span className="material-symbols-rounded">bar_chart_4_bars</span>
        </button>
        {/* {onItemForecast && (
          <button type="button" className="product-row-action-btn" title="Item Forecast" onClick={onItemForecast}>
            <img src={Forecasts} style={{ width: '21px', padding: '3px' }} />
          </button>
        )} */}
        <button type="button" className="product-row-action-btn" title="Duplicate" onClick={onCopy}>
          <i className="far fa-copy"></i>
        </button>
        <button type="button" className="product-row-action-btn danger" title="Delete" onClick={onDelete}>
          <i className="far fa-trash-alt"></i>
        </button>
        {(approvalStatus === "Approved" ||
          approvalStatus === "RequiresResubmission") &&
          isRequester && (
            <i
              className="fas fa-exclamation-triangle"
              style={{
                cursor: "pointer",
                color: "#66BB6A",
              }}
              onClick={(e) =>
                onApprovalIndicator(
                  approvalStatus === "RequiresResubmission"
                    ? "requiresResubmission"
                    : "approved",
                  e,
                  item
                )
              }
            />
          )}
        {approvalStatus === "Pending" && isRequester && (
          <i
            className="fas fa-exclamation-triangle"
            style={{ cursor: "pointer", color: "#FFA726" }}
            onClick={(e) => onApprovalIndicator("pending", e, item)}
          ></i>
        )}
        {approvalStatus === "Rejected" && isRequester && (
          <i
            className="fas fa-exclamation-triangle"
            style={{ cursor: "pointer", color: "#EF5350" }}
            onClick={(e) => onApprovalIndicator("rejected", e, item)}
          ></i>
        )}
        {approvalStatus === "Cancelled" && isRequester && (
          <i
            className="fas fa-exclamation-triangle"
            style={{ cursor: "pointer", color: "#6c757d" }}
            title="Cancelled approval details"
            onClick={(e) => onApprovalIndicator("cancelled", e, item)}
          ></i>
        )}
      </div>
    </td>
  );
});

const ProductQuotationRow = memo(function ProductQuotationRow({
  currencyDetail,
  companyBaseCurrency,
  errorItem,
  rangeErrorItem,
  index,
  item,
  isSelectedForForecast,
  isForecastedItem,
  isRevisionDraft = false,
  multiplierPermission,
  quotePending,
  rename,
  renameError,
  selectedLineCancelled,
  userProfile,
  values,
  onForecastSelect,
  onActionableApproval,
  onApprovalIndicator,
  onCopy,
  onDelete,
  onEdit,
  onForecast,
  onItemForecast,
  onMarginBlur,
  onMarginChange,
  onRename,
  onRenameBlur,
  onRenameChange,
  onRenameKeyDown,
}) {
  const actuatorCost = item?.productItems?.[0]?.productItemVariants
    ?.find((variant) => variant?.variantId === 50)?.variantValue || 0;
  const netPrice = calculateNetPrice(item);
  // Backend returns values already converted; show them as they are.
  const conv = (amount) => Number(amount) || 0;
  const totalDdp = item?.totalDdp
  const productDiscount = multiplierPermission?.maximumDiscount;
  const isRequester = quotePending?.data?.requesterIdentityId === userProfile?.identityId;

  const rowClassName = getRowClassName({ item, selectedLineCancelled, quotePending });
  return (
    <tr
      key={item?.id || index}
      className={rowClassName}
    >
      <td className="forecast-select-cell" style={{ width: 44, textAlign: "center" }}>
        <input
          type="checkbox"
          checked={!!isSelectedForForecast && !isForecastedItem}
          disabled={isRevisionDraft || !!isForecastedItem}
          onChange={() => onForecastSelect(item)}
          aria-label={`Select ${item?.markName} for forecast`}
          aria-disabled={isRevisionDraft || !!isForecastedItem}
          title={
            isRevisionDraft
              ? "Forecasting is unavailable while revision draft is active"
              : isForecastedItem
                ? "Already forecasted"
                : `Select ${item?.markName} for forecast`
          }
          className={isForecastedItem ? "forecast-row-checkbox forecast-row-checkbox-disabled" : "forecast-row-checkbox"}
        />
      </td>
      <ProductMarkCell
        item={item}
        rename={rename}
        renameError={renameError}
        onEdit={() => onEdit(item)}
        onRename={() => onRename(item)}
        onRenameBlur={onRenameBlur}
        onRenameChange={(markName) => onRenameChange({ ...rename, markName })}
        onRenameKeyDown={onRenameKeyDown}
      />
      <td data-label="Model Number" style={{ textAlign: "left" }}>{item?.productName}</td>
      <td data-label="Quantity" style={{ textAlign: "right" }}>{item?.quoteQuantity}</td>
      {canViewCosting(userProfile) && (
        <td data-label="Material cost" style={{ textAlign: "right" }}>
          {FormatValueDecimal(conv(item?.materialCost))}
        </td>
      )}
      {canViewCosting(userProfile) && (
        <td data-label="Labour cost" style={{ textAlign: "right" }}>
          {FormatValueDecimal(conv(item?.labourCost))}
        </td>
      )}
      {canViewCosting(userProfile) && (
        <td data-label="Actuator cost" style={{ textAlign: "right", display: "none" }}>
          {actuatorCost}
        </td>
      )}
      <td data-label="List Price" style={{ textAlign: "right" }}>
        {FormatValueDecimal(conv(item?.listPrice))}
      </td>
      <ProductMarginCell
        errorItem={errorItem}
        rangeErrorItem={rangeErrorItem}
        index={index}
        item={item}
        productDiscount={productDiscount}
        onActionableApproval={onActionableApproval}
        onBlur={onMarginBlur}
        onChange={onMarginChange}
      />

      <td data-label="Net Price" style={{ textAlign: "right" }}>
        {FormatValueDecimal(conv(netPrice))}
      </td>
      <td data-label="Total DDP" style={{ textAlign: "right" }}>
        {FormatValueDecimal(conv(totalDdp))}
      </td>
      <ProductRowActions
        item={item}
        isRequester={isRequester}
        quotePending={quotePending}
        onApprovalIndicator={onApprovalIndicator}
        onCopy={() => onCopy(item)}
        onDelete={() => onDelete(item)}
        onForecast={() => onForecast(item)}
        isRevisionDraft={isRevisionDraft}
        onItemForecast={onItemForecast ? () => onItemForecast(item) : undefined}
      />
    </tr>
  );
});

export const ProductQuotationGrid = memo(function ProductQuotationGrid({
  currencyDetail,
  companyBaseCurrency,
  multiplierError,
  marginRangeError,
  quotePending,
  rename,
  renameError,
  selectedLineCancelled,
  userMultiplier,
  userProfile,
  values,
  selectedForecastIds,
  allSelectableForecastSelected,
  partiallySelectableForecastSelected,
  selectableForecastCount = 0,
  isRevisionDraft = false,
  isForecastedItem,
  onActionableApproval,
  onApprovalIndicator,
  onCopy,
  onDelete,
  onEdit,
  onForecast,
  onForecastSelect,
  onForecastSelectAll,
  onItemForecast,
  onMarginBlur,
  onMarginChange,
  onRename,
  onRenameBlur,
  onRenameChange,
  onRenameKeyDown,
}) {
  return (
    <div className="table-responsive product-quotation-grid">
      <label className="quote-product-select-all d-block d-md-none">
        <input
          type="checkbox"
          checked={!!allSelectableForecastSelected}
          disabled={isRevisionDraft || selectableForecastCount === 0}
          onChange={onForecastSelectAll}
          ref={(input) => {
            if (input) input.indeterminate = !!partiallySelectableForecastSelected;
          }}
          aria-label="Select all forecastable marks"
          className="mr-1 forecast-row-checkbox forecast-row-checkbox--select-all"
        />
        <span>Select all</span>
      </label>
      <table className="table table-borderless">
        <thead>
          <tr>
            <th className="forecast-select-header" style={{ width: 44, textAlign: "center" }}>
              <input
                type="checkbox"
                checked={!!allSelectableForecastSelected}
                disabled={isRevisionDraft || selectableForecastCount === 0}
                onChange={onForecastSelectAll}
                ref={(input) => {
                  if (input) input.indeterminate = !!partiallySelectableForecastSelected;
                }}
                aria-label="Select all forecastable marks"
                className="forecast-row-checkbox forecast-row-checkbox--select-all"
              />
            </th>
            <th>Mark</th>
            <th>Model Number</th>
            <th className="sales-margin">Quantity</th>
            {canViewCosting(userProfile) && <th className="sales-margin">Material cost</th>}
            {canViewCosting(userProfile) && <th className="sales-margin">Labour cost</th>}
            {canViewCosting(userProfile) && (
              <th className="sales-margin" style={{ display: "none" }}>Actuator cost</th>
            )}
            <th className="sales-margin">List price</th>
            <th className="sales-margin product-margin-header"> Margin(+) / Discount(-) </th>
            <th className="sales-margin">Net price</th>
            <th className="sales-margin">Total DDP</th>
            <th className="sales-margin action-column-header"></th>
          </tr>
        </thead>
        <tbody>
          {values?.products?.map((item, index) => (
            <ProductQuotationRow
              key={item?.id ?? item?.quoteProductId}
              currencyDetail={currencyDetail}
              companyBaseCurrency={companyBaseCurrency}
              errorItem={multiplierError?.find((errItem) => errItem?.id === item?.id)}
              rangeErrorItem={marginRangeError?.find((errItem) => errItem?.id === item?.id)}
              index={index}
              item={item}
              isSelectedForForecast={selectedForecastIds?.[item?.id]}
              isForecastedItem={isForecastedItem?.(item)}
              isRevisionDraft={isRevisionDraft}
              multiplierPermission={userMultiplier?.mlpPermissions?.find((userMul) => userMul?.productGroupId === item?.groupId)}
              quotePending={quotePending}
              rename={rename}
              renameError={renameError}
              selectedLineCancelled={selectedLineCancelled}
              userProfile={userProfile}
              values={values}
              onForecastSelect={onForecastSelect}
              onActionableApproval={onActionableApproval}
              onApprovalIndicator={onApprovalIndicator}
              onCopy={onCopy}
              onDelete={onDelete}
              onEdit={onEdit}
              onForecast={onForecast}
              onItemForecast={onItemForecast}
              onMarginBlur={onMarginBlur}
              onMarginChange={onMarginChange}
              onRename={onRename}
              onRenameBlur={onRenameBlur}
              onRenameChange={onRenameChange}
              onRenameKeyDown={onRenameKeyDown}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
});
